/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { PractitionerStrictHttpResponse } from '../../practitioner-strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { PractitionerModel } from '../../models/practitioner-model';

export interface ConsumerPost$Params {
      body?: PractitionerModel
}

export function consumerPost(http: HttpClient, rootUrl: string, params?: ConsumerPost$Params, context?: HttpContext): Observable<PractitionerStrictHttpResponse<string>> {
  const rb = new RequestBuilder(rootUrl, consumerPost.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as PractitionerStrictHttpResponse<string>;
    })
  );
}

consumerPost.PATH = '/Consumer';
